// Definisi menu sidebar per peran. Dipindah dari App.jsx supaya Sidebar bisa
// diimpor tanpa lingkaran impor; App.jsx masih mengekspor ulang `getNav`.
//
// Bentuk elemen:
//   { section, key }            judul grup; `key` stabil lintas bahasa (dipakai
//                               untuk mengingat grup mana yang dilipat)
//   { id, label, icon, footer? } butir menu; `footer` = menempel di dasar sidebar
//
// `opts.superAdmin`: butir yang hanya milik admin lembaga (SUPER_ADMIN) tampil.
// Peran UI 'admin' mencakup SUPER_ADMIN dan PROGRAM_ADMIN, jadi `role` saja tidak
// cukup membedakannya. Server tetap penegaknya; ini hanya soal apa yang ditawarkan.
export function getNav(role, t, lang, opts = {}) {
  // FR-28: platform staff operate above the institutions, so the institution
  // menus (courses, sessions, certificates…) do not apply to them.
  if (role === "platform") {
    return [
      { section: (lang === "id" ? "Platform" : "Platform").toUpperCase(), key: "platform" },
      { id: "platform", label: t.navInstitutions, icon: "users" },
    ]
  }
  if (role === "participant") {
    return [
      { section: t.home.toUpperCase(), key: "home" },
      { id: "dashboard", label: t.home, icon: "home" },
      { id: "courses", label: t.myCourses, icon: "book" },
      { id: "videos", label: t.videos, icon: "play" },
      { id: "training", label: t.navTraining, icon: "calendar" },
      // Kehadiran normalnya dicatat peserta sendiri lewat pemindaian QR sesi.
      // Staf bisa mengoreksinya manual dari layar Detail Sesi (mis. QR gagal
      // atau absensi di kertas); baris seperti itu ditandai "Manual" supaya
      // tidak tersamar sebagai pemindaian terverifikasi.
      // Layar tujuannya sudah lama menangani peserta (QRAttendanceScreen
      // mengembalikan ParticipantScannerView untuk mereka), tetapi menunya
      // hanya pernah diberikan ke pelatih dan admin. Jadi kemampuannya ada,
      // pintunya tidak — dan kehadiran mustahil tercatat sampai hal ini
      // ketahuan di ruang pelatihan.
      { id: "qr", label: t.navAttendance, icon: "qr" },
      { section: t.progress.toUpperCase(), key: "progress" },
      { id: "pretest", label: t.pretest, icon: "check" },
      { id: "posttest", label: t.posttest, icon: "check" },
      { id: "learning-gain", label: t.learningGain, icon: "trending_up" },
      { id: "certificates", label: t.certificates, icon: "cert" },
      { id: "feedback", label: t.fbNav, icon: "caption" },
    ]
  }
  if (role === "trainer") {
    // Menu dikelompokkan menurut alur kerja, bukan menurut jenis halamannya.
    // Butir pertama sengaja tanpa judul grup: satu butir tidak perlu judul.
    return [
      { id: "dashboard", label: t.home, icon: "home" },
      { section: t.navTeaching.toUpperCase(), key: "teaching" },
      { id: "training", label: t.navTraining, icon: "calendar" },
      { id: "qr", label: t.navAttendance, icon: "qr" },
      { id: "courses", label: t.courses, icon: "book" },
      { id: "emails", label: t.navEmails, icon: "mail" },
      { section: t.navContent.toUpperCase(), key: "content" },
      { id: "course-manage", label: t.navManageCourses, icon: "edit" },
      { id: "videos", label: t.videos, icon: "play" },
      { id: "kb", label: t.knowledgeBase, icon: "bookmark" },
      { id: "doc-library", label: t.cmsTitle, icon: "layers" },
      { id: "test-editor", label: t.navTestEditor, icon: "list" },
      { section: t.navInsights.toUpperCase(), key: "insights" },
      { id: "reports", label: t.reports, icon: "doc" },
      { id: "learning-gain", label: t.learningGain, icon: "trending_up" },
      { id: "progress", label: t.analytics, icon: "pie" },
      { id: "ai", label: t.aiAssistant, icon: "ai" },
    ]
  }
  // admin
  return [
    { id: "dashboard", label: t.home, icon: "home" },
    { section: t.navTeaching.toUpperCase(), key: "teaching" },
    { id: "training", label: t.navTraining, icon: "calendar" },
    { id: "qr", label: t.navAttendance, icon: "qr" },
    { id: "courses", label: t.courses, icon: "book" },
    { id: "emails", label: t.navEmails, icon: "mail" },
    // Integrasi akun Zoom lembaga: hanya Super Admin yang bisa mengaturnya (server
    // menegakkannya). `brand` memilih logo Zoom sebagai ganti ikon garis; `icon`
    // jadi cadangan bagi pemakai lain daftar ini, mis. pencarian Ctrl+K.
    ...(opts.superAdmin ? [{ id: "zoom", label: "Zoom", icon: "video", brand: "zoom" }] : []),
    { section: t.navContent.toUpperCase(), key: "content" },
    ...(opts.superAdmin ? [{ id: "programs-manage", label: t.navManagePrograms, icon: "layers" }] : []),
    { id: "course-manage", label: t.navManageCourses, icon: "edit" },
    { id: "videos", label: t.videos, icon: "play" },
    { id: "kb", label: t.knowledgeBase, icon: "bookmark" },
    { id: "doc-library", label: t.cmsTitle, icon: "layers" },
    { id: "test-editor", label: t.navTestEditor, icon: "list" },
    { section: t.navPeople.toUpperCase(), key: "people" },
    { id: "enrollment", label: t.navEnrollment, icon: "user_plus" },
    { id: "users", label: t.users, icon: "users" },
    { id: "cert-send", label: t.sendCode, icon: "key" },
    { id: "certificates", label: t.certificates, icon: "cert" },
    { id: "penilaian", label: t.navAppraisals, icon: "star" },
    { section: t.navInsights.toUpperCase(), key: "insights" },
    { id: "reports", label: t.reports, icon: "doc" },
    { id: "learning-gain", label: t.learningGain, icon: "trending_up" },
    { id: "progress", label: t.analytics, icon: "pie" },
    { id: "ai", label: t.aiAssistant, icon: "ai" },
    { id: "feedback", label: t.fbNav, icon: "caption" },
    // `footer`: dirender terpisah di dasar sidebar, di luar daftar yang bergulir.
    { id: "settings", label: t.settings, icon: "cog", footer: true },
  ]
}

// Seluruh butir menu sebagai daftar datar, masing-masing membawa judul grupnya
// (`group`, null untuk butir tanpa grup). Dipakai pencarian/palet Ctrl+K.
export function navEntries(nav) {
  const { groups, footerItems } = groupNav(nav)
  return [
    ...groups.flatMap((g) => g.items.map((item) => ({ ...item, group: g.title }))),
    ...footerItems.map((item) => ({ ...item, group: null })),
  ]
}

// Memecah array datar `getNav` menjadi grup untuk dirender. Butir sebelum judul
// pertama masuk ke grup tanpa judul; butir `footer` dipisahkan.
export function groupNav(nav) {
  const footerItems = nav.filter((item) => item.footer)
  const groups = []
  let lead = []
  nav.filter((item) => !item.footer).forEach((item) => {
    if (item.section) {
      groups.push({ key: item.key || item.section, title: item.section, items: [] })
    } else if (groups.length) {
      groups[groups.length - 1].items.push(item)
    } else {
      lead.push(item)
    }
  })
  if (lead.length) groups.unshift({ key: "_lead", title: null, items: lead })
  return { groups, footerItems }
}
